import React from "react";
import PropTypes from "prop-types";

const componentName = "Timeline";

const Timeline = ({ items, titleBuilder, subTitleBuilder, bodyBuilder, selectedItemId, itemRef }) => {

  return (
    <div className="vertical-timeline-container">
      {items?.length > 0 ? items.map((item, idx) => {
        const ref = selectedItemId && selectedItemId === item.noteId ? itemRef : null;
        const itemKey = item?.id ?? item?.noteId ?? item?.referenceId ?? idx;
        const subTitle = subTitleBuilder?.(item, idx);

        return (
            <div key={itemKey} ref={ref} className="vertical-timeline vertical-timeline--one-column">
              <div className="vertical-timeline-item vertical-timeline-element">
                <div>
                    <span className="vertical-timeline-element-icon mt-3">
                      <i id={`${componentName}-tlMark-${idx}`} className="badge bg-white p-2 border rounded-circle"> </i>
                    </span>
                    <div id={`${componentName}-tl-${idx}`} className="vertical-timeline-element-content bg-white border rounded-3 p-3">
                      {subTitle ? <h4 id={`${componentName}-tlTitle-${idx}`} className="timeline-title">
                        {subTitle}
                      </h4> : null}
                      <div id={`${componentName}-tlInfo-${idx}`} className="mb-0">
                        {bodyBuilder?.(item, idx)}
                      </div>
                      <span id={`${componentName}-tlMeta-${idx}`} className="vertical-timeline-element-date mt-3 text-break" style={{width: "99px"}}>
                        <span className="d-block">
                          {titleBuilder?.(item, idx)}
                        </span>
                      </span>
                    </div>
                </div>
              </div>
            </div>
        );
      }):<div className="my-3 mx-2">No Records Found</div>}
    </div>
  );
};

Timeline.propTypes = {
  items: PropTypes.array,
  titleBuilder: PropTypes.func,
  subTitleBuilder: PropTypes.func,
  bodyBuilder: PropTypes.func,
  selectedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export { Timeline };
